// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__383hs","right":"styles_right__1ruMn"};